/* eslint-disable sonarjs/no-duplicate-string */
const previewOpenEnded = require('@/assets/images/slide-type-preview/open-ended.svg')
const previewWordCloud = require('@/assets/images/slide-type-preview/word-cloud.svg')
const previewScale = require('@/assets/images/slide-type-preview/scales.svg')
const previewQuestion = require('@/assets/images/slide-type-preview/q&a.svg')
const previewPickAnswer = require('@/assets/images/slide-type-preview/pick-answer.svg')
const previewPickImage = require('@/assets/images/slide-type-preview/pick-image.svg')
const previewTypeAnswer = require('@/assets/images/slide-type-preview/type-answer.svg')
const previewHeading = require('@/assets/images/slide-type-preview/heading.svg')
const previewBulletPoints = require('@/assets/images/slide-type-preview/list.svg')
const previewQrcode = require('@/assets/images/slide-type-preview/qr-code.svg')
const previewImage = require('@/assets/images/slide-type-preview/image.svg')
const previewYoutube = require('@/assets/images/slide-type-preview/youtube.svg')
const previewDocument = require('@/assets/images/slide-type-preview/document.svg')
const previewGoogleSlide = require('@/assets/images/slide-type-preview/google-slides.svg')
const previewSpinnerWheel = require('@/assets/images/slide-type-preview/spinner-wheel.svg')
const previewBrainstorm = require('@/assets/images/slide-type-preview/brainstorm.svg')
const previewMatchPairs = require('@/assets/images/slide-type-preview/match-pairs.svg')
const previewCorrectOrder = require('@/assets/images/slide-type-preview/correct-order.svg')
const previewPoll = require('@/assets/images/slide-type-preview/poll.svg')
const previewContent = require('@/assets/images/slide-type-preview/content.svg')

const allSlideTypes = [
  {
    title: 'Popular',
    key: 'popular',
    desc: 'Popular',
    slideTypes: [
      {
        name: 'Poll',
        icon: 'fas fa-signal',
        type: 'imageChoice',
        desc: 'Pose a question, provide the options and let participants choose one or more. You can also add images',
        ahaIcon: 'multiple-choice',
        ahaIconWhite: 'multiple-choice-w',
        preview: 'poll',
        previewUrl: previewPoll,
      },
      {
        name: 'Pick Answer',
        icon: 'fas fa-tasks',
        type: 'pickAnswer',
        slideType: null,
        desc: 'Ask a quiz question and write the options. Participants try to choose the correct answer to score points.',
        label: 'Quiz',
        ahaIcon: 'pick-answer',
        ahaIconWhite: 'pick-answer-w',
        preview: 'pickAnswer',
        previewUrl: previewPickAnswer,
      },
      {
        name: 'Word Cloud',
        type: 'wordCloud',
        icon: 'fas fa-cloud',
        desc: 'Pose a question and let participants write 1 or 2-word answers. The more popular an answer is, the larger it will appear on screen.',
        ahaIcon: 'word-cloud',
        ahaIconWhite: 'word-cloud-w',
        preview: 'wordCloud',
        previewUrl: previewWordCloud,
        videoTutorialUrl: 'https://www.youtube.com/embed/fAIi4n1V8yk',
      },
      {
        name: 'Spinner Wheel',
        icon: 'fas fa-keyboard',
        type: 'spinnerWheel',
        desc: 'Ask quiz questions, or play games, and let your participants compete for victory!',
        label: '',
        ahaIcon: 'spinner-wheel',
        ahaIconWhite: 'spinner-wheel-w',
        preview: 'spinnerWheel',
        previewUrl: previewSpinnerWheel,
        videoTutorialUrl: 'https://www.youtube.com/embed/-PaqZrxnDOw',
      },
      {
        name: 'Content',
        type: 'freestyle',
        desc: 'Add and edit text, images and bullet points.',
        ahaIcon: 'content',
        ahaIconWhite: 'content-w',
        preview: 'content',
        previewUrl: previewContent,
      },
    ],
  },
  {
    title: 'Quiz',
    key: 'quiz',
    desc: 'Ask quiz questions, or play games, and let your participants compete for victory!',
    slideTypes: [
      {
        name: 'Pick Answer',
        icon: 'fas fa-tasks',
        type: 'pickAnswer',
        slideType: null,
        desc: 'Ask a quiz question and write the options. Participants try to choose the correct answer to score points.',
        label: 'Quiz',
        ahaIcon: 'pick-answer',
        ahaIconWhite: 'pick-answer-w',
        preview: 'pickAnswer',
        previewUrl: previewPickAnswer,
      },
      {
        name: 'Pick Image',
        icon: 'fas fa-images',
        type: 'pickAnswer',
        slideType: 'imageChoice',
        desc: 'Ask a quiz question and provide image options. Participants try to choose the correct image to score points.',
        label: 'Quiz',
        ahaIcon: 'pick-image',
        ahaIconWhite: 'pick-image-w',
        preview: 'pickImage',
        previewUrl: previewPickImage,
      },
      {
        name: 'Type Answer',
        icon: 'fas fa-keyboard',
        type: 'pickAnswer',
        slideType: 'typeAnswer',
        desc: 'Ask a quiz question and write in the answer(s) that you will accept. Participants try to write the correct answer and will score points if it matches your accepted answer(s).',
        label: 'Quiz',
        ahaIcon: 'type-answer',
        ahaIconWhite: 'type-answer-w',
        preview: 'typeAnswer',
        previewUrl: previewTypeAnswer,
      },
      {
        name: 'Spinner Wheel',
        icon: 'fas fa-keyboard',
        type: 'spinnerWheel',
        desc: 'Ask quiz questions, or play games, and let your participants compete for victory!',
        label: '',
        ahaIcon: 'spinner-wheel',
        ahaIconWhite: 'spinner-wheel-w',
        preview: 'spinnerWheel',
        previewUrl: previewSpinnerWheel,
        videoTutorialUrl: 'https://www.youtube.com/embed/-PaqZrxnDOw',
      },
      {
        name: 'Match Pairs',
        type: 'pickAnswer',
        slideType: 'matchPairs',
        desc: 'Pose a question and provide prompts and answers. Participants try to match each prompt to its accompanying answer.',
        label: 'Quiz',
        ahaIcon: 'match-pairs',
        ahaIconWhite: 'match-pairs-w',
        preview: 'matchPairs',
        previewUrl: previewMatchPairs,
      },
      {
        name: 'Correct Order',
        type: 'pickAnswer',
        slideType: 'correctOrder',
        desc: 'Provide up to 10 mixed-up options and let participants order them.',
        label: 'Quiz',
        ahaIcon: 'correct-order',
        ahaIconWhite: 'correct-order-w',
        preview: 'correctorder',
        previewUrl: previewCorrectOrder,
      },
      {
        name: 'Leaderboard',
        type: 'leaderboard',
        noType: true,
      },
    ],
  },
  {
    title: 'Poll',
    key: 'poll',
    desc: 'Collect opinions from your audience in a range of formats, or address their questions through a Q&A slide!',
    slideTypes: [
      {
        name: 'Poll',
        icon: 'fas fa-signal',
        type: 'multipleChoice',
        desc: 'Pose a question, provide the options and let participants choose one or more. You can also add images',
        ahaIcon: 'multiple-choice',
        ahaIconWhite: 'multiple-choice-w',
        preview: 'poll',
        previewUrl: previewPoll,
        hidden: true,
      },
      {
        name: 'Poll',
        icon: 'fas fa-signal',
        type: 'imageChoice',
        desc: 'Pose a question, provide the options and let participants choose one or more. You can also add images',
        ahaIcon: 'multiple-choice',
        ahaIconWhite: 'multiple-choice-w',
        preview: 'poll',
        previewUrl: previewPoll,
      },
      {
        name: 'Open Ended',
        icon: 'fas fa-comment-dots',
        type: 'openEnded',
        desc: 'Pose a question and let participants freely write their responses. Set fields for participants´ names, teams, emails or avatars.',
        ahaIcon: 'open-ended',
        ahaIconWhite: 'open-ended-w',
        preview: 'openEnded',
        previewUrl: previewOpenEnded,
        videoTutorialUrl: 'https://www.youtube.com/embed/O7o7j4BZDDc',
      },
      {
        name: 'Word Cloud',
        type: 'wordCloud',
        icon: 'fas fa-cloud',
        desc: 'Pose a question and let participants write 1 or 2-word answers. The more popular an answer is, the larger it will appear on screen.',
        ahaIcon: 'word-cloud',
        ahaIconWhite: 'word-cloud-w',
        preview: 'wordCloud',
        previewUrl: previewWordCloud,
        videoTutorialUrl: 'https://www.youtube.com/embed/fAIi4n1V8yk',
      },
      {
        name: 'Scales',
        type: 'scale',
        icon: 'fas fa-sliders-h',
        desc: 'Pose a question, write statements and let your participants rate each statement on a scale. Results are shown in a colour-coded graph that shows the popularity of each statement.',
        ahaIcon: 'scales',
        ahaIconWhite: 'scales-w',
        preview: 'scale',
        previewUrl: previewScale,
      },
      {
        name: 'Q&A',
        type: 'question',
        icon: 'fas fa-comment',
        iconInside: true,
        desc: 'Participants write and vote on questions for you to answer. All questions are displayed on screen for you to address one by one. Pin questions to save them or mark as answered to remove them.',
        ahaIcon: 'qa',
        ahaIconWhite: 'q&a-w',
        preview: 'question',
        previewUrl: previewQuestion,
        videoTutorialUrl: 'https://www.youtube.com/embed/Z1kCoy9i6N0',
      },
      {
        name: 'Brainstorm',
        type: 'ideas',
        icon: 'fas fa-comment',
        iconInside: true,
        desc: 'Provide a topic and let the audience submit their ideas. Each participant votes for their favourite ideas and the results are ranked by popularity.',
        ahaIcon: 'brainstorm',
        ahaIconWhite: 'brainstorm-white',
        preview: 'brainstorm',
        previewUrl: previewBrainstorm,
        videoTutorialUrl: 'https://www.youtube.com/embed/JaxWbKImUcQ',
      },
    ],
  },
  {
    title: 'Content',
    key: 'content',
    desc: 'Add text content, image, video... to your presentation',
    slideTypes: [
      {
        name: 'Content',
        type: 'freestyle',
        desc: 'Add and edit text, images and bullet points.',
        ahaIcon: 'content',
        ahaIconWhite: 'content-w',
        preview: 'content',
        previewUrl: previewContent,
      },
      {
        name: 'Heading',
        subheading: 'Subheading',
        type: 'textSlide',
        desc: 'Write a heading and an optional subheading. You can use this for introducing a question or quiz slide. This slide type also works great as an opening to a new section of the presentation.',
        ahaIcon: 'heading',
        ahaIconWhite: 'heading-w',
        preview: 'heading',
        previewUrl: previewHeading,
      },
      {
        name: 'List',
        type: 'bulletPoints',
        html: '<i class="fas fa-list bulletPoints-icon"></i>',
        desc: 'Write a bullet point list. You can also add a heading and a subheading.',
        ahaIcon: 'list',
        ahaIconWhite: 'list-w',
        preview: 'bulletPoints',
        previewUrl: previewBulletPoints,
      },
      {
        name: 'QR Code',
        type: 'qrcode',
        icon: 'fas fa-qrcode',
        desc: 'Display the unique QR code for your presentation. Participants can scan this on their devices to join your quiz. Tip: You can also show this QR code on any other slide types by clicking the top of your slide.',
        ahaIcon: 'qr-code',
        ahaIconWhite: 'qr-code-w',
        preview: 'qrcode',
        previewUrl: previewQrcode,
      },
      {
        name: 'Image',
        type: 'image',
        icon: 'far fa-image',
        desc: 'Display an image either centrally on the slide or full-screen. Use your own images or choose ones from our library.',
        ahaIcon: 'type-image',
        ahaIconWhite: 'image-w',
        preview: 'image',
        previewUrl: previewImage,
      },
      {
        name: 'YouTube',
        type: 'youtube',
        icon: 'fab fa-youtube',
        desc: 'Embed a YouTube video. Simply copy and paste the YouTube URL into the slide.',
        ahaIcon: 'youtube',
        ahaIconWhite: 'youtube-w',
        preview: 'youtube',
        previewUrl: previewYoutube,
      },
      {
        name: 'Document',
        type: 'document',
        icon: 'fas fa-file-import',
        desc: 'Import a PowerPoint or PDF document into this presentation.',
        ahaIcon: 'document',
        ahaIconWhite: 'document-w',
        preview: 'document',
        previewUrl: previewDocument,
        hidden: true,
      },
      {
        name: 'Google Slides',
        type: 'googleSlides',
        icon: 'fab fa-google',
        desc: 'Embed a Google Slides presentation. The entire slideshow will be displayed within this one slide.',
        ahaIcon: 'google-slides',
        ahaIconWhite: 'google-slides-w',
        preview: 'googleSlides',
        previewUrl: previewGoogleSlide,
      },
    ],
  },
]

export default allSlideTypes
